import axios from 'axios';

/**
 * Nahrání souboru přes podepsanou URL vydanou API (endpoint `/storage`).
 *
 * Jeden PUT celého obsahu; podpis je v query, takže Content-Type můžeme posílat volně.
 *
 * @param file       Soubor / Blob k nahrání.
 * @param signedUrl  Podepsané URL pro zápis získané z API.
 * @returns          URL objektu bez query (bez podpisu).
 */
export const handleBlobFileUpload = async (file: File, signedUrl: string): Promise<string> => {
    try {
        await axios.put(signedUrl, file, {
            headers: {
                'Content-Type': file.type || 'application/octet-stream',
            },
        });
        return signedUrl.split('?')[0];
    } catch (error) {
        console.error('File upload failed:', error);
        throw error;
    }
};
